<style lang="scss" scoped>
.wxEditor {
  border: 1px solid #dcdfe6;
  background: #fff;
}
.bar {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #dcdfe6;
  .item {
    cursor: pointer;
    padding: 0 20px;
    display: block;
    float: left;
    color: #9a9a9a;
    &.active {
      color: #173bcf;
    }
  }
  i {
    font-size: 14px;
  }
}
.content {
  position: relative;
  padding: 14px 20px;
  height: 188px;
  overflow: auto;
}
.text {
  color: #353535;
  height: 148px;
  overflow-y: auto;
  word-break: break-all;
  line-height: 20px;
  /deep/ .emoji {
    background: transparent !important;
    cursor: unset;
    vertical-align: -8px;
  }
}
.footer {
  box-sizing: border-box;
  padding: 0 20px;
  color: #9a9a9a;
  border-top: 1px solid #dcdfe6;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 40px;
  line-height: 40px;
}

/deep/ .emoji {
  display: inline-block;
  cursor: pointer;
  width: 25px;
  &:hover {
    background: #efefef;
  }
}
.upload {
  width: 100%;
  height: 100%;
  /deep/ {
    .el-upload,
    .lib {
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
}
.article {
  display: inline-block;
  border: 1px solid #dcdfe6;
  position: relative;
  text-align: left;
  width: 300px;
  cursor: pointer;
  padding-bottom: 10px;
  .title {
    padding: 0 10px;
    box-sizing: border-box;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
  }
  .desc {
    padding: 8px;
    line-height: 19px;
  }
  .img {
    width: 100%;
    height: 160px;
  }
  &.multi {
    .first {
      position: relative;
      .title {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
      }
    }
    .other {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #dcdfe6;
      padding: 15px 0;
      &:last-child {
        border: none;
      }
      .title {
        font-size: 14px;
        line-height: 20px;
        height: 60px;
      }
      .img {
        flex-shrink: 0;
        margin-right: 10px;
        margin-left: 10px;
        width: 80px;
        height: 80px;
      }
    }
  }
}
.link {
  display: inline-block;
  width: 400px;
  height: 108px;
  border: 1px solid #bdc7db;
  padding: 20px 15px;
  position: relative;
  .title {
    color: #000;
    font-size: 18px;
    margin-bottom: 15px;
  }
  .info {
    width: 240px;
  }
  .desc {
    font-size: 16px;
    color: #9a9a9a;
  }
  .img {
    position: absolute;
    bottom: 20px;
    right: 15px;
    width: 80px;
    height: 80px;
  }
}
.sound {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .iconyuyin {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
.video {
  vertical-align: middle;
  display: inline-block;
  padding: 15px 20px;
  width: 240px;
  .el-icon-video-play {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
  }
}
</style>

<template>
  <div class="wxEditor">
    <div class="bar clearfix">
      <div
        class="item"
        v-for="item in items"
        :key="item.text"
        :class="{active:item.type == type}"
        @click="type = item.type"
        v-show="!reply || item.type != 'link'"
      >
        <i class="iconfont" :class="item.icon"></i>
        {{item.text}}
      </div>
    </div>
    <div class="content" v-show="type == 'text'" style="overflow:hidden">
      <div class="text" contenteditable @blur="setSel" @input="input($event)" ref="contenteditable"></div>
      <div class="footer clearfix">
        <el-popover placement="bottom-start" width="400" trigger="click">
          <div class="fl pointer" slot="reference">
            <i class="iconfont iconbiaoqing"></i>
          </div>
          <div class="clearfix">
            <img
              class="emoji"
              :src="`${publicPath}emoji/${item.name}.png`"
              v-for="item in emoji"
              @click="addEmoji(item)"
              :key="item.name"
            />
          </div>
        </el-popover>
        <div
          class="fr"
          v-if="count(content.text) <= textSize"
        >还可以输入{{textSize - count(content.text)}}字，按下Enter键换行</div>
        <div class="fr" v-else>
          <span style="color:red">已超出{{count(content.text) - textSize}}字</span>，按下Enter键换行
        </div>
      </div>
    </div>
    <div class="content" v-show="type == 'image'">
      <div v-if="Object.keys(content.image).length">
        <el-image
          class="border middle"
          style="width: 182px; height: 122px"
          :src="content.image.content.thumbUrl"
          fit="contain"
        ></el-image>
        <imageLib @confirm="confirm($event,'image')">
          <el-tooltip effect="dark" content="编辑" placement="top">
            <el-button icon="el-icon-edit-outline" circle class="ml10" size="mini"></el-button>
          </el-tooltip>
        </imageLib>
        <el-tooltip effect="dark" content="删除" placement="top">
          <el-button icon="el-icon-delete" circle size="mini" class="ml10" @click="del('image')"></el-button>
        </el-tooltip>
      </div>
      <el-row class="h100" :gutter="20" v-else>
        <el-col :span="12" class="h100">
          <imageLib class="upload" @confirm="confirm($event,'image')">
            <add>从素材库中选择</add>
          </imageLib>
        </el-col>
        <el-col :span="12" class="h100">
          <el-upload
            class="upload"
            :show-file-list="false"
            action
            :before-upload="beforeFn"
            :http-request="uploadImage"
            accept="image/jpeg, image/png, image/bmp, image/gif"
          >
            <add>上传图片</add>
          </el-upload>
        </el-col>
      </el-row>
    </div>
    <div class="content" v-show="type == 'article'">
      <div v-if="Object.keys(content.article).length">
        <div class="article multi middle">
          <template v-if="content.article.content.news.length>1">
            <div v-for="(item2,index) in content.article.content.news" :key="index">
              <template v-if="!index">
                <div class="first">
                  <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                  <div class="title line1">{{item2.title}}</div>
                </div>
              </template>
              <template v-else>
                <div class="other">
                  <div class="title line3">{{item2.title}}</div>
                  <el-image :src="item2.thumbUrl" lazy fit="cover" class="img"></el-image>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div class="title line1">{{content.article.content.news[0].title}}</div>
            <el-image :src="content.article.content.news[0].thumbUrl" lazy fit="cover" class="img"></el-image>
            <div class="desc">{{content.article.content.news[0].digest}}</div>
          </template>
        </div>
        <articleLib @confirm="confirm($event,'article')" :reply="reply">
          <el-tooltip effect="dark" content="编辑" placement="top">
            <el-button icon="el-icon-edit-outline" circle class="ml10" size="mini"></el-button>
          </el-tooltip>
        </articleLib>
        <el-tooltip effect="dark" content="删除" placement="top">
          <el-button icon="el-icon-delete" circle size="mini" class="ml10" @click="del('article')"></el-button>
        </el-tooltip>
      </div>
      <el-row class="h100" :gutter="20" v-else>
        <el-col :span="12" class="h100">
          <articleLib class="upload" @confirm="confirm($event,'article')" :reply="reply">
            <add>从素材库中选择</add>
          </articleLib>
        </el-col>
      </el-row>
    </div>
    <div class="content" v-show="type == 'sound'">
      <template v-if="Object.keys(content.sound).length">
        <div class="sound border line1">
          <i class="iconfont iconyuyin middle mr10" @click="play(content.sound.content)"></i>
          <span>{{content.sound.content.title}}</span>
        </div>
        <soundLib @confirm="confirm($event,'sound')">
          <el-tooltip effect="dark" content="编辑" placement="top">
            <el-button icon="el-icon-edit-outline" circle class="ml10" size="mini"></el-button>
          </el-tooltip>
        </soundLib>
        <el-tooltip effect="dark" content="删除" placement="top">
          <el-button icon="el-icon-delete" circle size="mini" class="ml10" @click="del('sound')"></el-button>
        </el-tooltip>
      </template>
      <el-row class="h100" :gutter="20" v-else>
        <el-col :span="12" class="h100">
          <soundLib class="upload" @confirm="confirm($event,'sound')">
            <add>从素材库中选择</add>
          </soundLib>
        </el-col>
        <el-col :span="12" class="h100">
          <soundAdd class="upload">
            <add>新建语音</add>
          </soundAdd>
        </el-col>
      </el-row>
    </div>
    <div class="content" v-show="type == 'video'">
      <template v-if="Object.keys(content.video).length">
        <div class="video border line1">
          <i
            class="iconfont el-icon-video-play middle mr10"
            @click="playVideo(content.video.content.videoUrl)"
          ></i>
          <span>{{content.video.content.title}}</span>
        </div>
        <videoLib @confirm="confirm($event,'video')">
          <el-tooltip effect="dark" content="编辑" placement="top">
            <el-button icon="el-icon-edit-outline" circle class="ml10" size="mini"></el-button>
          </el-tooltip>
        </videoLib>
        <el-tooltip effect="dark" content="删除" placement="top">
          <el-button icon="el-icon-delete" circle size="mini" class="ml10" @click="del('sound')"></el-button>
        </el-tooltip>
      </template>
      <el-row class="h100" :gutter="20" v-else>
        <el-col :span="12" class="h100">
          <videoLib class="upload" @confirm="confirm($event,'video')">
            <add>从素材库中选择</add>
          </videoLib>
        </el-col>
      </el-row>
    </div>
    <div class="content" v-show="type == 'link'">
      <div v-if="Object.keys(content.link).length">
        <div class="link">
          <div class="info">
            <div class="title line2">{{content.link.content.title }}</div>
            <div class="desc line3">{{content.link.content.digest}}</div>
          </div>
          <img
            :src="content.link.content.thumbUrl"
            class="img"
            v-if="content.link.content.thumbUrl"
          />
        </div>
        <el-tooltip effect="dark" content="删除" placement="top">
          <el-button icon="el-icon-delete" circle size="mini" class="ml10" @click="del('link')"></el-button>
        </el-tooltip>
      </div>
      <el-row class="h100" :gutter="20" v-else>
        <el-col :span="12" class="h100">
          <linkAdd class="upload" @confirm="confirm($event,'link')">
            <add>新建外链消息</add>
          </linkAdd>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import soundManager from 'soundmanager2';
import emojiMap from '@/assets/encode-mapping';
import add from '@/components/add';
import imageLib from '@/components/lib/imageLib';
import articleLib from '@/components/lib/articleLib';
import soundLib from '@/components/lib/soundLib';
import soundAdd from '@/components/lib/soundAdd';
import videoLib from '@/components/lib/videoLib';
import linkAdd from '@/components/lib/linkAdd';

export default {
  props: ['reply'],
  beforeRouteLeave(to, from, next) {
    if (this.voice) {
      this.voice.stop();
      this.voice.destruct();
    }
    next();
  },
  components: {
    add,
    imageLib,
    articleLib,
    soundLib,
    soundAdd,
    videoLib,
    linkAdd,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    let emoji = [];
    for (const key in emojiMap) {
      emoji.push({
        key,
        name: emojiMap[key].name,
      });
    }
    return {
      publicPath: process.env.BASE_URL,
      emoji,
      type: 'text',
      textSize: 600,
      content: {
        text: '',
        image: {},
        article: {},
        sound: {},
        link: {},
        video: {},
      },
      sel: null,
      range: null,
      items: [
        {
          icon: 'iconwenzi',
          text: '文字',
          type: 'text',
        },
        {
          icon: 'icontupian',
          text: '图片',
          type: 'image',
        },
        {
          icon: 'icontuwen',
          text: '图文',
          type: 'article',
        },
        {
          icon: 'iconyuyin',
          text: '语音',
          type: 'sound',
        },
        {
          icon: 'iconshipin',
          text: '视频',
          type: 'video',
        },
        {
          icon: 'iconwailian',
          text: '外链消息',
          type: 'link',
        },
      ],
    };
  },
  watch: {
    type() {
      this.setFocus();
    },
  },
  methods: {
    filter(html) {
      var dom = document.createElement('div');
      dom.innerHTML = html;

      $(dom)
        .find('.emoji')
        .each((i, item) => {
          let alt = $(item).attr('alt');
          $(item).replaceWith(alt);
        });
      return $(dom)
        .html()
        .replace(/<br>/g, '\n')
        .replace(/<div>/g, '')
        .replace(/<\/div>/g, '');
    },
    count(content) {
      let html = this.filter(content);
      html = html
        .replace(/<br>/g, '\n')
        .replace(/<div>/g, '')
        .replace(/<\/div>/g, '');
      return html.length;
    },
    playVideo(url) {
      window.open(url);
    },
    play(content) {
      if (this.voice) {
        this.voice.stop();
        this.voice.destruct();
      }
      soundManager.soundManager.setup({
        onready: () => {
          this.voice = soundManager.soundManager.createSound({
            url: content.voiceUrl,
          });
          this.voice.play();
        },
        waitForWindowLoad: true,
      });
    },
    confirm(item, type) {
      console.log(item);
      this.content[type] = {
        ...item,
      };
    },
    del(type) {
      this.content[type] = {};
    },
    async uploadImage(file) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '2');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      let res2 = await this.$http.post(`/api/${this.id}/material/image`, {
        title: res.name,
        thumburl: res.url,
      });
      console.log(res2);
      this.content.image = res2.material;
      return;
    },
    beforeFn(file) {
      if (file.size > 2048 * 1024) {
        this.$message.error(`图片大小不能超过2mb`);
        return false;
      }
      return true;
    },
    getData(key) {
      if (key) {
        if (this.type == 'text') {
          return {
            replyType: 1,
            material: {
              content: {
                text: JSON.stringify([
                  this.content.text,
                  this.filter(this.content.text),
                ]),
              },
            },
          };
        }
        return {
          replyType:
            this.items.findIndex(item => item.type == this.type) + 1 == 6
              ? 10
              : this.items.findIndex(item => item.type == this.type) + 1,
          material: this.content[this.type],
        };
      }
      if (this.type == 'text') {
        return {
          replyType: 1,
          content: [this.content.text, this.filter(this.content.text)],
        };
      }
      return {
        replyType:
          this.items.findIndex(item => item.type == this.type) + 1 == 6
            ? 10
            : this.items.findIndex(item => item.type == this.type) + 1,
        content: this.content[this.type],
      };
    },
    postData() {
      let data = this.getData();
      let obj = {};
      if (data.replyType != 1) {
        obj.materialid = data.content.materialId;
      } else {
        obj.text = JSON.stringify(data.content);
      }
      obj.replyType = data.replyType == 6 ? 10 : data.replyType;
      return obj;
    },
    setData(res) {
      let replyType = res.replyType == 10 ? 6 : res.replyType;
      this.type = this.items[replyType - 1].type;
      if (res.replyType == 1) {
        let html = JSON.parse(res.material.content.text)[0];
        this.$refs.contenteditable.innerHTML = html;
        this.input();
      } else {
        this.content[this.type] = res.material;
      }
    },
    clear() {
      this.type = 'text';
      this.$refs.contenteditable.innerHTML = '';
      this.content.text = '';
      this.content.image = {};
      this.content.article = {};
      this.content.sound = {};
      this.content.video = {};
      this.content.link = {};
    },
    setFocus() {
      if (this.type == 'text') {
        this.$nextTick(() => {
          let el = this.$refs.contenteditable;
          el.focus();
        });
      }
    },
    setSel() {
      this.sel = window.getSelection();
      this.range = window.getSelection().getRangeAt(0);
    },
    input(e) {
      this.content.text = this.$refs.contenteditable.innerHTML;
    },
    insertHtmlAtCaret(html) {
      var sel, range;
      if (window.getSelection) {
        sel = this.sel;
        if (sel.getRangeAt && sel.rangeCount) {
          range = this.range;
          range.deleteContents();
          var el = document.createElement('div');
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.collapseToEnd();
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type != 'Control') {
        document.selection.createRange().pasteHTML(html);
      }
    },
    addEmoji(item) {
      let emoji = `<img class="emoji" alt="${item.key}" src="${this.publicPath}emoji/${item.name}.png"/>`;
      this.insertHtmlAtCaret(emoji);
      this.input();
    },
    validate() {
      let res = this.getData();
      if (res.replyType == 1) {
        if (!res.content[1]) {
          this.$message.error('请输入文字内容');
          return false;
        }
        if (res.content[1].length > 600) {
          this.$message.error('输入文字最多600字');
          return false;
        }
      }

      return true;
    },
  },
  mounted() {
    console.log(this.publicPath);
    this.setFocus();
  },
};
</script>
